// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("./node_modules/.pnpm/webpack-dev-server@5.2.6_webpack-cli@6.0.1_webpack@5.106.2/node_modules/webpack-dev-server/client/index.js?protocol=ws%3A&hostname=0.0.0.0&port=3040&pathname=%2Fws&logging=verbose&overlay=true&reconnect=10&hot=true&live-reload=false");
__webpack_require__("./node_modules/.pnpm/webpack@5.106.2_esbuild@0.25.12_webpack-cli@6.0.1/node_modules/webpack/hot/dev-server.js");
var __webpack_exports__ = __webpack_require__("./src/index.tsx");
